import React from 'react';
import { Main } from '@klp/layout';
import { Portfolio } from '@klp/portfolio/classes/Portfolio';
import { Region } from '@klp/portfolio/classes/Region';
import { contractToRegistrationStatus } from '@klp/contractregistration/config';
import { localStorageReferences as contextSelectorStorageReferences } from '@klp/contextSelector/utils';
import { localStorageReferences as kommentarerLocalStorageReferences } from '@klp/kommentarer/utils';
import { localStorageReferences as prosjektLocalStorageReferences } from '@klp/prosjekt/config';
import { useAppParams } from '@forvalter/packages/appParams/useAppParams';
import { clearStorage } from '@forvalter/utils/storage';
import { Typography } from '@klp/design';
import { clearAllFilterStorage } from '@klp/design/PersistentFilter/config';
import { AuthLogout } from '@klpkonsern/auth-core/routes';

export const LogoutView: React.FC = () => {
    const appParams = useAppParams();
    const clearAppData = async () => {
        try {
            appParams.byggNummer = undefined;
            appParams.isAdmin = undefined;
            appParams.sakId = undefined;
            appParams.contractPath = undefined;
            appParams.messageId = undefined;

            Portfolio.storedSelectedPortfolio = undefined;
            Region.storedSelectedRegion = undefined;

            await Promise.all([
                clearStorage(contractToRegistrationStatus),
                clearStorage(contextSelectorStorageReferences.SELECTED_CONTEXT),
                clearStorage(kommentarerLocalStorageReferences.SELECTED_DATE),
                clearStorage(
                    prosjektLocalStorageReferences.SELECTED_PROSJEKT_STATUS,
                ),
                clearAllFilterStorage(),
            ]);

            sessionStorage.removeItem('storedByggnummer');
            sessionStorage.removeItem('storedKundenummer');
        } catch (error) {
            console.error('Error clearing application data:', error);
        }
    };

    return (
        <AuthLogout onLogout={clearAppData}>
            <Main
                withoutHeader={true}
                withoutSidebar={true}
                centered={true}
                fullScreen={true}
            >
                <Typography
                    klpHeadingLevel="ONE"
                    translation="auth.loggingOut"
                />
            </Main>
        </AuthLogout>
    );
};
